import React from "react";
import { confirmAlert } from "react-confirm-alert";
import AppConfirm from "../../../components/elements/app-confirm/appConfirm";

export function useAppConfirm() {
  const showConfirm = (
    header: string,
    message: string,
    yesBtnText = "Yes",
    noBtnText = "No",
    onClickYes: () => void,
    onClickNo: () => void,
    options?: {
      icon?: React.ReactNode;
      variant?: "default" | "danger";
    }
  ) => {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <AppConfirm
            onClose={onClose}
            message={message}
            header={header}
            yesBtnText={yesBtnText}
            noBtnText={noBtnText}
            onClickYes={onClickYes}
            onClickNo={onClickNo}
            icon={options?.icon}
            variant={options?.variant}
          />
        );
      },
      // eslint-disable-next-line @typescript-eslint/no-empty-function
      onClickOutside: () => {},
      // eslint-disable-next-line @typescript-eslint/no-empty-function
      onKeypressEscape: () => {},
    });
  };

  return showConfirm;
}
